import React from 'react';
import ErrorButton from '@material-ui/icons/Error';
import KioskLog from 'models/KioskLog';

class ErrorBoundary extends React.Component {
	constructor() {
		super();
		this.state = { errorInfo: null };
	}

	componentDidCatch(error, errorInfo) {
		// Catch errors in any components below
		this.setState({
			errorInfo,
		});
		// Log error message
		const log = new KioskLog(error);
		log.postMessage();
	}

	render() {
		if (this.state.errorInfo) {
			// Error path
			return (
				<div>
					<ErrorButton />
				</div>
			);
		}
		// Normally, just render children
		// eslint-disable-next-line react/prop-types
		return this.props.children;
	}
}

export default ErrorBoundary;
